import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/apps/abmeldung-digital/layouts/default.vue")),
  legal: defineAsyncComponent(() => import("/vercel/path0/apps/abmeldung-digital/layouts/legal.vue")),
  "ausserbetriebsetzung-flow": defineAsyncComponent(() => import("/vercel/path0/layers/ausserbetriebsetzung/layouts/ausserbetriebsetzung-flow.vue"))
}